import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';

import seoConfig from './seo.config.json';

const validRoutes = new Set(
  Object.keys(seoConfig).filter((route) => route !== '/' && route !== '/404')
);
validRoutes.add('/live-classes');

const TrailingSlashRedirect: React.FC = () => {
  const { pathname, search, hash } = useLocation();

  if (pathname !== '/' && !pathname.endsWith('/')) {
    const cleanPath = pathname.replace(/\/+$/, '');
    if (validRoutes.has(cleanPath)) {
      return <Navigate to={`${cleanPath}/${search}${hash}`} replace />;
    }
  }

  return null;
};

export default TrailingSlashRedirect;
